import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * Centered empty state for lists, tables, and filter panels.
 */
export default function EmptyState({
  icon: Icon = InboxOutlinedIcon,
  title,
  description,
  action,
  compact = false,
  sx,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: compact ? 3 : 5,
        px: 3,
        color: 'var(--color-text-secondary)',
        ...sx,
      }}
    >
      {Icon && (
        <Icon
          sx={{
            fontSize: compact ? 40 : 48,
            mb: 1.5,
            color: 'var(--color-text-disabled)',
          }}
        />
      )}
      {title && (
        <Typography
          variant={compact ? 'body2' : 'subtitle1'}
          fontWeight={600}
          color="text.primary"
          sx={{ mb: description ? 0.5 : action ? 2 : 0 }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 420, mb: action ? 2 : 0, whiteSpace: 'pre-line' }}
        >
          {description}
        </Typography>
      )}
      {action}
    </Box>
  );
}
